export const LINK_DATA = 'data-link';
